import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Statistics1 from '../Statistics/Statistics1';
import Statistics2 from '../Statistics/Statistics2';
import Statistics3 from '../Statistics/Statistics3';

function Section2() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/mortgage-rates-settle-into-the-6-range',
      copy: 'settled in the 6% range',
      label: 'Read article, Mortgage Rates Settle Into the 6% Range'
    }
  ];

  return (
    <section className="sections">
      <h3 className="sections-sub">1. Interest rates stabilize</h3>
      <p className="sections-copy">
        “The mortgage interest rate looks like it has turned a corner,” says Dr. Yun. In late
        October 2022, the average rate on a 30-year mortgage was over 7%, whereas by late December,
        rates had declined meaningfully and <Hyperlink hyperlinkData={hyperlinkData[0]} />.
      </p>
      <p className="sections-copy">
        Even so, there’s still a record gap between average 30-year mortgage rates and 10-year
        Treasury rates. These two rates usually track each other quite closely – separated by a
        ‘spread’ or gap of about 1.5 or 2 percentage points – but in 2022, the spread jumped to an
        all-time high of more than 3 percentage points.
      </p>
      <div className="quote">
        <div className="quote__contents">
          <div className="quotationMark">“</div>
          <blockquote className="quote__copy">
            The mortgage interest rate looks like it has turned a corner. I think it’s clearly
            possible that we will have 30-year mortgage rates closer to 5% in 2023, which would do
            wonders for the housing market.”
          </blockquote>
          <div className="quote__caption">
            Dr. Lawrence Yun,{' '}
            <span className="italic">Chief Economist at the National Association of Realtors</span>
          </div>
        </div>
      </div>
      <p className="sections-copy">
        “We tend to see the gap widen at times of great uncertainty – for instance, when the Fed
        surprised the market by raising interest rates a little faster and more aggressively than
        had been anticipated,” explains Yun. “Now, I think we have better communication from the
        Fed, so there have been fewer surprises. As this uncertainty dissipates, the spread should
        move closer to its normal range. If that happens, I think it’s clearly possible that we will
        have 30-year mortgage rates closer to 5% in 2023, which would do wonders for the housing
        market.”
      </p>
      <p className="sections-copy sections-copy--margin">
        Lower mortgage interest rates typically stimulate buyer demand by reducing the amount that
        buyers need to pay each month for borrowing a certain amount of money. In addition, Yun
        points out that many potential sellers who enjoy low mortgage interest rates are reluctant
        to move right now because they are wary of signing up for a new loan at a much higher rate.
        If interest rates go down, that could help convince some potential sellers to list their
        homes and accept a slightly higher rate on a new mortgage in order to get a more spacious
        home or move closer to a new job in another part of town.
      </p>
      <Statistics1 />
      <h3 className="sections-sub">2. Home prices hold steady</h3>
      <p className="sections-copy sections-copy--margin">
        After several years in which median home prices rose at a double-digit pace, Yun expects
        home prices to flatten out in 2023, but he does not foresee any widespread decline in home
        prices like what we saw in the crash of 2008.
      </p>
      <Statistics2 />
      <p className="sections-copy">
        Simply put, the fundamentals of the 2023 housing market are very different from the
        conditions that prevailed 15 years ago. Back then, subprime loans were rampant, a building
        boom had led to a glut of available homes on the market, mortgage delinquency rates topped
        10%, and nearly 5% of homes were in foreclosure amid a recession tied to 8 million job
        losses.
      </p>
      <p className="sections-copy sections-copy--margin">
        Today, Yun says mortgages are sound thanks to policy reforms and stronger lending standards,
        delinquency rates are less than 4%, and inventories are low. In fact, one of the factors
        that has driven up home prices in recent years has been a housing shortage linked to the
        fact that new housing starts dramatically lagged historical averages even as the U.S.
        population continued to grow.
      </p>
      <Statistics3 />
      <p className="sections-copy">
        Of course, an actual job-cutting recession could lead to some forced sales. “But despite all
        the talk of an impending recession, we still have a labor shortage in this country with more
        job openings than applicants,” notes Yun. “In this type of job-creating environment, we are
        much less likely to see forced sales or any big increase in foreclosures. These are the
        driving forces that explain why home prices are unlikely to decline across the board.”
      </p>
    </section>
  );
}

export default Section2;
